module.exports = __webpack_public_path__ + "media/images/logo-lj-d456549ed06a14fda7b24fdd474ab004.svg";